export default __webpack_public_path__ + "static/media/img3.464916d6.jpg";